import { Outlet } from 'react-router-dom';
import { ChartPieSlice, ShareNetwork, ClipboardText, Package, Key, EnvelopeSimple, IdentificationCard, Trash, UserCircle, MapTrifold } from '@phosphor-icons/react';
import { useAuth, canEditIt } from '@/auth/AuthContext';
import { ModuleSidebar } from '@/components/enterprise/ModuleSidebar';

// Single source of nav items
const ITEMS = {
  dashboard: { to: '/it', end: true, label: 'ダッシュボード', icon: ChartPieSlice, testid: 'it-nav-dashboard' },
  myit: { to: '/it/my', label: 'マイデバイス', icon: UserCircle, testid: 'it-nav-myit' },
  staff: { to: '/it/staff', label: '社員IT台帳', icon: IdentificationCard, testid: 'it-nav-staff', admin: true },
  requests: { to: '/it/requests', label: '申請センター', icon: ClipboardText, testid: 'it-nav-requests' },
  assets: { to: '/it/assets', label: 'IT資産', icon: Package, testid: 'it-nav-assets' },
  floormap: { to: '/it/floormap', label: 'フロアマップ', icon: MapTrifold, testid: 'it-nav-floormap', admin: true },
  vlan: { to: '/it/vlan', label: 'VLAN・IP管理', icon: ShareNetwork, testid: 'it-nav-vlan' },
  licenses: { to: '/it/licenses', label: 'ライセンス管理', icon: Key, testid: 'it-nav-licenses', admin: true },
  emails: { to: '/it/emails', label: '会社メール管理', icon: EnvelopeSimple, testid: 'it-nav-emails', admin: true },
  disposals: { to: '/it/disposals', label: '廃棄履歴', icon: Trash, testid: 'it-nav-disposals', admin: true },
};

// Ordered by access frequency, grouped into two sections
const SECTIONS_DEF = [
  { label: '運用', keys: ['dashboard', 'myit', 'staff', 'requests'] },
  { label: '台帳・管理', keys: ['assets', 'floormap', 'vlan', 'licenses', 'emails', 'disposals'] },
];

export default function ITLayout() {
  const { user } = useAuth();
  const admin = canEditIt(user);
  const allow = (key) => !ITEMS[key].admin || admin;

  const sections = SECTIONS_DEF
    .map((s) => ({ label: s.label, items: s.keys.filter(allow).map((k) => ITEMS[k]) }))
    .filter((s) => s.items.length > 0);

  return (
    <div className="flex flex-col md:flex-row gap-5 md:gap-6" data-testid="it-layout">
      <ModuleSidebar
        icon={ShareNetwork}
        title="ITシステム管理"
        sections={sections}
        testid="it-sidebar"
      />
      <div className="flex-1 min-w-0">
        <Outlet />
      </div>
    </div>
  );
}
